import type { AvailabilitySlot } from "../types";

const fullDateFormatter = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  weekday: "long",
  day: "2-digit",
  month: "2-digit",
});

const timeFormatter = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatSlotDate(iso: string) {
  return fullDateFormatter.format(new Date(iso));
}

export function formatSlotTime(start: string, end: string) {
  return `${timeFormatter.format(new Date(start))}–${timeFormatter.format(new Date(end))} Uhr`;
}

export function groupSlotsByDay(slots: AvailabilitySlot[]) {
  return slots.reduce<Record<string, AvailabilitySlot[]>>((groups, slot) => {
    const key = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "Europe/Berlin",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(slot.start));
    groups[key] ??= [];
    groups[key].push(slot);
    return groups;
  }, {});
}

export function formatAdminDateTime(iso: string) {
  return new Intl.DateTimeFormat("de-DE", {
    timeZone: "Europe/Berlin",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(iso));
}
